import { atom } from 'recoil';

export const acceptedAccessionTermsAtom = atom({
  key: 'acceptedAccessionTermsAtom',
  default: false,
});
